import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ReminderService } from './reminder.service';
import { ReminderAddModal } from './reminderAddModal/reminder.add.modal.component';
import { NotificationService } from '../../core/services/core.notification.service';
import { UiService } from '../../core/services/core.ui.service';

import * as _ from 'lodash';

@Component({
    selector: 'gf-reminders',
    template: require('./reminders.component.html')
})
export class RemindersComponent implements OnInit {

    @Input() section: string;
    @Input() refId: any;
    @Input() project: string;

    protected reminders: any;

    constructor(
        private reminderService: ReminderService,
        private modalService: NgbModal,
        private notificationService: NotificationService,
        private uiService: UiService) { }

    ngOnInit() {
        this.fetchReminders();
    };

    showAddReminder() {

        const modalRef = this.modalService.open(ReminderAddModal);
        modalRef.componentInstance.section = this.section;
        modalRef.componentInstance.refId = this.refId;
        modalRef.componentInstance.project = this.project;

        modalRef.result
        .then(() => {
            this.fetchReminders();
        }, (failure) => {
            console.log('Modal failure', failure);
        });
    };

    deleteReminder(reminder) {
        this.reminderService.delete(reminder.id)
            .then(() => {
                this.uiService.message.showSuccess('Reminder "' + reminder.label + '" deleted successfully', 'Reminder Deleted');
                _.remove(this.reminders, { id: reminder.id });
            })
            .catch(() => {
                this.uiService.message.showError('Reminder "' + reminder.label + '" couldn\'t be deleted', 'Reminder Delete Error');
            });
    };

    fetchReminders() {
        this.reminderService.fetch({ section: this.section, refId: this.refId })
            .then((ret) => {
                this.reminders = _.get(ret, 'items', []);

                //Publish event
                this.notificationService.notifyAll('REMINDER-ALERTS-UPDATED', { reminders: this.reminders });
            })
            .catch((err) => { console.log(err); });
    }
}